import _ from 'lodash';
import { EventBus } from '../../../../core/shared/helpers/EventHelper';
import ListComponent from '../../../../core/infraestructure/ListComponent';
import LiveClassViewModel from '../../../../core/features/liveclass/viewmodels/LiveClassViewModel';

export default {
  extends: ListComponent,
  data() {
    return {
      viewModel: null,
      searchName: '',
      modalItemLiveClass: {
        isVisible: false,
      },
      itemLiveClass: null,
      limit: 12,
      isSubscribed: false,
      studentInfoItem: null,
      modalSubscriptionInfo: {
        isVisible: false,
        isLoading: false,
      },
    };
  },
  computed: {
    filteredCollection() {
      if (!this.searchName) return this.collection || [];
      const term = this.searchName.toLowerCase().trim();
      return (this.collection || []).filter(item => {
        const title = (item.title || '').toLowerCase();
        const course = (item.course || '').toLowerCase();
        const instructor = (item.publisherTitle || '').toLowerCase();
        return title.includes(term) || course.includes(term) || instructor.includes(term);
      });
    },
  },
  created() {
    this.viewModel = new LiveClassViewModel(this);
    EventBus.$on('update-session', this.onUpdateSession);
    this.onActive();
  },
  beforeDestroy() {
    EventBus.$off('update-session', this.onUpdateSession);
  },
  methods: {
    onActive() {
      this.viewModel.onBindProfile();
      this.viewModel.findLiveClassesActives();
    },
    onSearch() {
      this.showLoading(true, 'Actualizando registros...');
      this.viewModel.findLiveClassesActives();
    },
    onAllFilterChange(data, field) {
      this.onFilterChange(data, field);
    },
    onSearchInput() {
      // Instant client-side filtering via computed property filteredCollection
    },
    onClearSearch() {
      this.searchName = '';
      this.onAllFilterChange('', 'Title');
    },
    onSearchSubmit() {
      this.onAllFilterChange(this.searchName, 'Title');
    },
    getYoutubeThumbnail(url) {
      if (!url) return null;
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
      const match = url.match(regExp);
      if (match && match[2] && match[2].length === 11) {
        return `https://img.youtube.com/vi/${match[2]}/hqdefault.jpg`;
      }
      return null;
    },
    mapProfileImageUrl(item) {
      if (!item) return '/images/left-imgs/img-1.jpg';
      if (item.publisher && item.publisher.profileImageUrl) return item.publisher.profileImageUrl;
      if (item.publisherImageUrl) return item.publisherImageUrl;
      return '/images/left-imgs/img-1.jpg';
    },
    onAvatarError(event) {
      if (event && event.target) {
        event.target.src = '/images/left-imgs/img-1.jpg';
      }
    },
    findLiveClassesActiveResponse(response) {
      this.collection = response;
    },
    onShowLiveClass(item) {
      if (this.isSubscribed) {
        this.itemLiveClass = item;
        this.viewModel.showModal(this.modalItemLiveClass, true);
      } else {
        this.$alert('Para ver el contenido de nuestros cursos, necesitas una subscripción activa.', 'Información', {
          confirmButtonText: 'Aceptar',
          callback: () => {
            this.$router.push('/estudiante/mi-cuenta');
          },
          confirmButtonClass: 'btn-cancel',
        });
      }
    },
    onUpdateSession(data) {
      if (data && data.user && data.user.hasSubscriptions && !data.user.hasSubscriptionInfo) {
        this.studentInfoItem = this.viewModel.onCreateStudentInfo();
        this.viewModel.showModal(this.modalSubscriptionInfo, true);
      }
    },
    isCollectionEmpty(collection) {
      return _.isEmpty(collection);
    },
  },
};
